import * as React from 'react'

import MemePostEditor from './meme-post-editor'
import PostInputPreview from './post-input-preview'

import { MemePost } from '@/types/meme.interface'

interface MemePostEditorContainerProps {
  editPost?: MemePost | null
  onCloseEdit?: () => void
}

function MemePostEditorContainer({ editPost, onCloseEdit }: MemePostEditorContainerProps) {
  const [isOpen, setIsOpen] = React.useState(!!editPost)

  React.useEffect(() => {
    if (editPost) {
      setIsOpen(true)
    }
  }, [editPost])

  const handleClose = (isOpen: boolean) => {
    setIsOpen(isOpen)
    if (!isOpen && onCloseEdit) {
      onCloseEdit()
    }
  }

  return (
    <div className="relative">
      {!editPost && <PostInputPreview onOpenEditor={() => setIsOpen(true)} />}
      {isOpen && <MemePostEditor setIsOpen={handleClose} editPost={editPost} />}
    </div>
  )
}

export default MemePostEditorContainer
